import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const ErrorFilled = createSvgIcon(
  <path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm6-13.125v2.25H6v-2.25h12Z" />,
  'ErrorFilled'
);

export { ErrorFilled };